<template>
    <div>
        <Loader :visible="isLoading" text="Esecuzione registrazione ticket in corso..." />

        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>

        <div class="p-6">
            <div class="bg-white rounded-md shadow-lg">
                <div class="px-6 py-3 bg-gray-100 rounded-t-md">
                    <h3 class="font-semibold">Registrazione Ore Ticket</h3>
                </div>

                <div class="p-6">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div>
                            <label class="block text-gray-700 mb-2 font-medium">Data Inizio</label>
                            <input
                                v-model="dataInizio"
                                type="date"
                                :max="dataFine || undefined"
                                class="p93__input w-full"
                            />
                        </div>
                        <div>
                            <label class="block text-gray-700 mb-2 font-medium">Data Fine</label>
                            <input
                                v-model="dataFine"
                                type="date"
                                :min="dataInizio || undefined"
                                class="p93__input w-full"
                            />
                        </div>
                    </div>

                    <div v-if="dataUltimoTicket" class="mb-4 flex items-center gap-2 text-sm text-gray-600">
                        <span class="font-medium">Ultimo ticket chiuso (pre-importazione) registrato il:</span>
                        <span class="bg-blue-50 text-blue-700 border border-blue-200 rounded px-2 py-0.5 font-mono">{{ formatDateTime(dataUltimoTicket) }}</span>
                    </div>

                    <div class="flex items-center gap-4">
                        <button
                            @click="eseguiComando"
                            :disabled="isLoading || !dataInizio || !dataFine"
                            class="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-2 rounded-md shadow-md transition-colors"
                        >
                            Esegui Registrazione
                        </button>
                        <button
                            v-if="risultato !== null"
                            @click="pulisciOutput"
                            class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md shadow-md transition-colors"
                        >
                            Pulisci
                        </button>
                    </div>
                </div>
            </div>

            <template v-if="risultato !== null">

                <div v-if="!risultato.success" class="mt-6 bg-white rounded-md shadow-lg">
                    <div class="px-6 py-3 bg-red-100 rounded-t-md flex items-center justify-between">
                        <h3 class="font-semibold text-red-800">
                            Errore durante l'esecuzione
                        </h3>
                        <span class="text-xs text-gray-500">{{ executedAt }}</span>
                    </div>
                    <div class="p-4">
                        <pre class="bg-gray-900 text-red-400 p-4 rounded-md text-sm font-mono overflow-x-auto whitespace-pre-wrap max-h-[600px] overflow-y-auto">{{ risultato.output || '(nessun output)' }}</pre>
                    </div>
                </div>

                <template v-else>

                    <div class="mt-6 bg-white rounded-md shadow-lg">
                        <div class="px-6 py-3 bg-green-100 rounded-t-md flex items-center justify-between">
                            <h3 class="font-semibold text-green-800">
                                Ticket registrati
                                <span class="ml-2 text-sm font-normal">({{ risultato.ticket_registrati.length }})</span>
                            </h3>
                            <span class="text-xs text-gray-500">{{ executedAt }}</span>
                        </div>
                        <div class="p-4">
                            <div v-if="risultato.ticket_registrati.length === 0" class="text-gray-500 text-sm">
                                Nessun ticket registrato.
                            </div>
                            <table v-else class="w-full text-sm border-collapse">
                                <thead>
                                    <tr class="bg-gray-50 text-left">
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Ticket</th>
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Contratto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, i) in risultato.ticket_registrati" :key="i" class="hover:bg-gray-50">
                                        <td class="px-4 py-2 border border-gray-200">{{ row.ticket }}</td>
                                        <td class="px-4 py-2 border border-gray-200">{{ row.contratto }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="risultato.contratti_non_registrati.length > 0" class="mt-6 bg-white rounded-md shadow-lg">
                        <div class="px-6 py-3 bg-yellow-100 rounded-t-md">
                            <h3 class="font-semibold text-yellow-800">
                                Contratti non trovati
                                <span class="ml-2 text-sm font-normal">({{ risultato.contratti_non_registrati.length }})</span>
                            </h3>
                        </div>
                        <div class="p-4">
                            <table class="w-full text-sm border-collapse">
                                <thead>
                                    <tr class="bg-gray-50 text-left">
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Cod. Cliente</th>
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Ragione Sociale</th>
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Contratto</th>
                                        <th class="px-4 py-2 border border-gray-200 font-medium">Ticket</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, i) in risultato.contratti_non_registrati" :key="i" class="hover:bg-yellow-50">
                                        <td class="px-4 py-2 border border-gray-200">{{ row.cod_cli }}</td>
                                        <td class="px-4 py-2 border border-gray-200">{{ row.company }}</td>
                                        <td class="px-4 py-2 border border-gray-200">{{ row.contratto }}</td>
                                        <td class="px-4 py-2 border border-gray-200">{{ Array.isArray(row.tickets) ? row.tickets.join(', ') : row.tickets }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </template>

            </template>
        </div>

        <ConfirmationModal :show="showConfermaModal" @close="showConfermaModal = false">
            <template #title>
                Periodo antecedente
            </template>
            <template #content>
                La data di inizio selezionata è antecedente di oltre 2 mesi rispetto alla data odierna.
                Sei sicuro di voler procedere con la registrazione per questo periodo?
            </template>
            <template #footer>
                <SecondaryButton @click="showConfermaModal = false">
                    Annulla
                </SecondaryButton>
                <PrimaryButton class="ms-3" @click="confermaProcedi">
                    Procedi
                </PrimaryButton>
            </template>
        </ConfirmationModal>
    </div>
</template>

<script>
import axios from 'axios';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import Loader from '@/Components/Loader.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';

export default {
    components: {
        BreadCrumbs,
        ConfirmationModal,
        Loader,
        PrimaryButton,
        SecondaryButton,
    },
    props: {
        dataUltimoTicket: {
            type: String,
            default: null,
        },
    },
    data() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const formatted = yesterday.toISOString().substring(0, 10);

        return {
            dataInizio: formatted,
            dataFine: formatted,
            isLoading: false,
            risultato: null,
            executedAt: null,
            showConfermaModal: false,
            navigation: [
                { name: 'Dashboard', href: route('dashboard') },
                { name: 'Contratti', href: route('modules.home', 'contratti') },
                { name: 'Registrazione Ticket', href: route('modules.contratti.registrazione-ticket') },
            ],
        };
    },
    methods: {
        periodoAntecedente() {
            const due_mesi_fa = new Date();
            due_mesi_fa.setMonth(due_mesi_fa.getMonth() - 2);
            due_mesi_fa.setHours(0, 0, 0, 0);
            return new Date(this.dataInizio) < due_mesi_fa;
        },
        eseguiComando() {
            if (!this.dataInizio || !this.dataFine) {
                return;
            }
            if (this.periodoAntecedente()) {
                this.showConfermaModal = true;
                return;
            }
            this.eseguiChiamata();
        },
        confermaProcedi() {
            this.showConfermaModal = false;
            this.eseguiChiamata();
        },
        async eseguiChiamata() {
            this.isLoading = true;
            this.risultato = null;

            try {
                const response = await axios.post(route('modules.contratti.registrazione-ticket.esegui'), {
                    dataInizio: this.dataInizio,
                    dataFine: this.dataFine,
                });

                this.risultato = response.data;
                this.executedAt = new Date().toLocaleString('it-IT');
            } catch (error) {
                this.risultato = {
                    success: false,
                    output: error.response?.data?.message ?? 'Errore durante l\'esecuzione del comando.',
                    ticket_registrati: [],
                    contratti_non_registrati: [],
                };
                this.executedAt = new Date().toLocaleString('it-IT');
            } finally {
                this.isLoading = false;
            }
        },
        pulisciOutput() {
            this.risultato = null;
            this.executedAt = null;
        },
    },
};
</script>
